import {
  AddonCategory,
  MarketplaceAddon,
  Partnership,
} from "../entities/marketplace.entities";

export interface MarketplaceDataState {
  addons: MarketplaceAddon[];
  purchasedAddons: MarketplaceAddon[];
  bestSellerAddons: MarketplaceAddon[];
  banners: MarketplaceAddon[];
  categories: { category: AddonCategory; addons: MarketplaceAddon[] }[];
  partners: Partnership[];
  selectedAddon?: MarketplaceAddon;
}

export interface MarketplaceUiState {
  loading: boolean;
  loadingDetail: boolean;
}

export interface MarketplaceState {
  data: MarketplaceDataState;
  ui: MarketplaceUiState;
}

export const initialState: MarketplaceState = {
  data: {
    addons: [],
    purchasedAddons: [],
    bestSellerAddons: [],
    banners: [],
    categories: [],
    partners: [],
    selectedAddon: undefined,
  },
  ui: {
    loading: false,
    loadingDetail: false,
  },
};
